import type { StepDisplayState } from "../../../api/threads/liveMessages";
import { chipToneClass, type ChipTone } from "../../../ui/styles/chipStyles";

/** The chip tone of a step's state as module C shows it (W-22), wherever a step's state is shown. */
export const STEP_STATE_TONE: Readonly<Record<StepDisplayState, ChipTone>> = {
  upcoming: "neutral",
  ready: "info",
  needs_input: "warning",
  input: "warning",
  approval: "warning",
  offline: "neutral",
  slot: "info",
  queued: "info",
  running: "info",
  done: "success",
  failed: "danger",
  skipped: "warning",
};

/**
 * The same as classes, for the workflow graph's NodeControls until it renders Chip
 * (baseline entry in shared-components.json); remove it then.
 */
export const STEP_STATE_CHIP: Readonly<Record<StepDisplayState, string>> = {
  upcoming: chipToneClass(STEP_STATE_TONE.upcoming),
  ready: chipToneClass(STEP_STATE_TONE.ready),
  needs_input: chipToneClass(STEP_STATE_TONE.needs_input),
  input: chipToneClass(STEP_STATE_TONE.input),
  approval: chipToneClass(STEP_STATE_TONE.approval),
  offline: chipToneClass(STEP_STATE_TONE.offline),
  slot: chipToneClass(STEP_STATE_TONE.slot),
  queued: chipToneClass(STEP_STATE_TONE.queued),
  running: chipToneClass(STEP_STATE_TONE.running),
  done: chipToneClass(STEP_STATE_TONE.done),
  failed: chipToneClass(STEP_STATE_TONE.failed),
  skipped: chipToneClass(STEP_STATE_TONE.skipped),
};
